import { Link } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { useState, useEffect } from "react";

const RoleBasedProtectedRoute = ({ children, allowedRole = [], backTo }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { accessToken, role } = useAuthStore();

  useEffect(() => {
    if (!accessToken) {
      setIsOpen(true);
    } else if (accessToken && !allowedRole.includes(role)) {
      setIsOpen(true);
    }
  }, [accessToken, allowedRole, role]);

  const handleClose = () => {
    setIsOpen(false);
    if (accessToken) {
      window.location.href = backTo;
    } else {
      window.location.href = "/clients/signin";
    }
  };

  if (accessToken && allowedRole.includes(role)) {
    return children;
  }

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white text-gray-800 rounded-lg shadow-lg w-96 max-w-[90vw]">
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-[#174568]">Access Denied</h2>
              <Link
                to={backTo}
                className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
              >
                ×
              </Link>
            </div>

            {/* Body */}
            <div className="px-6 py-4">
              <p>
                {!accessToken
                  ? "You must be logged in to access this page."
                  : "You do not have permission to access this page."}
              </p>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
              <button
                onClick={handleClose}
                className="bg-[#174568] hover:bg-[#0f3347] text-white font-medium px-4 py-2 rounded transition"
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RoleBasedProtectedRoute;